import { useTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";
import PageWrap from "components/PageWrap/PageWrap";
import LoadResolver from "components/LoadResolver";
import { useSelector } from "react-redux";

function UserInformationPage() {
  const { isLoading, error, item } = useSelector((state) => state.activeUser);
  const { t } = useTranslation("common");
  return (
    <PageWrap page="userData" t={t}>
      <LoadResolver isLoading={isLoading} error={error}>
        <UserInfo user={item} t={t} />
      </LoadResolver>
    </PageWrap>
  );
}

const UserInfo = ({ user, t }) => {
  if (!user) return null;
  return (
    <Grid columns={2} className="info-grid">
      <Grid.Row>
        <Grid.Column width={2}>{t("email")}</Grid.Column>
        <Grid.Column>
          {user.email}{" "}
          <span className="secondary-info">
            {t(user.email_verified ? "verified" : "not_verified")}
          </span>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={2}>{t("phone_number")}</Grid.Column>
        <Grid.Column>
          {user.phone_number}{" "}
          <span className="secondary-info">
            {t(user.phone_number_verified ? "verified" : "not_verified")}
          </span>
        </Grid.Column>
      </Grid.Row>
      {user.groups && (
        <Grid.Row>
          <Grid.Column width={2}>{t("groups")}</Grid.Column>
          <Grid.Column>{user.groups.join(", ")}</Grid.Column>
        </Grid.Row>
      )}
    </Grid>
  );
};

export default UserInformationPage;
